import React from 'react';
import { ChatGlyph, ChevronGlyph } from './chatIcons';
import classes from './ChatLauncher.module.css';

const MAX_BADGE_COUNT = 9;

/** The round button that opens and closes the comments, with an unread badge while closed. */
const ChatLauncher = ({ isOpen, unreadCount, onToggle }) => {
    const label = isOpen ? 'Close comments' : 'Open comments';
    const hasUnread = unreadCount > 0 && !isOpen;
    const badgeLabel = unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : `${unreadCount}`;

    return (
        <button
            type="button"
            className={classes.launcher}
            onClick={onToggle}
            aria-label={label}
            aria-expanded={isOpen}
            title={label}
        >
            {/* Keyed so React remounts it and replays the swap animation. */}
            <span key={isOpen ? 'open' : 'closed'} className={classes.glyph} aria-hidden="true">
                {isOpen ? <ChevronGlyph /> : <ChatGlyph />}
            </span>
            {hasUnread && (
                <span className={classes.unreadBadge} aria-live="polite">
                    {badgeLabel}
                    <span className={classes.srOnly}> unread messages</span>
                </span>
            )}
            {hasUnread && <span className={classes.pulseRing} aria-hidden="true" />}
        </button>
    );
};

export default ChatLauncher;
